import styled, { css } from 'styled-components';

import { Span } from './Generic';
import Ai from './Icons/Ai';
import Athletics from './Icons/Athletics';
import Biathlon from './Icons/Biathlon';
import Climbing from './Icons/Climbing';
import CombatSport from './Icons/CombatSport';
import Communication from './Icons/Communication';
import Course from './Icons/Course';
import Customization from './Icons/Customization';
import Cycling from './Icons/Cycling';
import Cyclocross from './Icons/Cyclocross';
import Dashboard from './Icons/Dashboard';
import DragHandle from './Icons/DragHandle';
import Duathlon from './Icons/Duathlon';
import Facilities from './Icons/Facilities';
import Finance from './Icons/Finance';
import Fishing from './Icons/Fishing';
import Fitness from './Icons/Fitness';
import Football from './Icons/Football';
import Golf from './Icons/Golf';
import GravelCycling from './Icons/GravelCycling';
import Handball from './Icons/Handball';
import Hockey from './Icons/Hockey';
import HorseRiding from './Icons/HorseRiding';
import Hourglass from './Icons/Hourglass';
import IceSkating from './Icons/IceSkating';
import Kitesurfing from './Icons/Kitesurfing';
import Mountainbiking from './Icons/Mountainbiking';
import ObstacleRun from './Icons/ObstacleRun';
import Other from './Icons/Other';
import Pending from './Icons/Pending';
import Registration from './Icons/Registration';
import Resale from './Icons/Resale';
import Rowing from './Icons/Rowing';
import Running from './Icons/Running';
import SC from './SC';
import Sailing from './Icons/Sailing';
import Skiing from './Icons/Skiing';
import StartFinish from './Icons/StartFinish';
import Surfing from './Icons/Surfing';
import Swimming from './Icons/Swimming';
import Tennis from './Icons/Tennis';
import Ticket from './Icons/Ticket';
import TrailRunning from './Icons/TrailRunning';
import Triathlon from './Icons/Triathlon';
import Volleyball from './Icons/Volleyball';
import Walking from './Icons/Walking';
import Yoga from './Icons/Yoga';

export interface IconProps {
  size?: number;
  strong?: boolean;
}

export const Icon = styled(Span)<SC<IconProps>>`
  ${({ sc: { size = 1, strong } = {} }) => css`
    display: inline-block;
    vertical-align: middle;
    margin-bottom: 2.5px;

    > * {
      height: ${size}em;
      width: ${size}em;
      display: block;
    }

    > span {
      display: flex;
      align-items: center;
      justify-content: center;
    }

    strong & svg {
      stroke-width: 2.5;
    }

    ${strong && css`
      svg {
        stroke-width: 2.5;
      }
    `}
  `}
`;

export const Icons = {
  Ticket,
  Resale,
  Course,
  Facilities,
  StartFinish,
  Finance,
  Communication,
  Customization,
  Registration,
  Dashboard,
  Hourglass,
  Ai,
  Pending,
  DragHandle,

  // Sport types
  Running,
  TrailRunning,
  Cycling,
  GravelCycling,
  Mountainbiking,
  Cyclocross,
  Athletics,
  Biathlon,
  Climbing,
  CombatSport,
  Duathlon,
  Fishing,
  Fitness,
  Football,
  Golf,
  Handball,
  Hockey,
  HorseRiding,
  IceSkating,
  Kitesurfing,
  ObstacleRun,
  Rowing,
  Sailing,
  Skiing,
  Surfing,
  Swimming,
  Tennis,
  Triathlon,
  Volleyball,
  Walking,
  Yoga,
  Other,
};

export default undefined;
